<template>
  <div class="ff-infotip">
    <div
      class="ff-infotip__trigger"
      @mouseenter="trigger"
      @mouseleave="triggerLeave">
      <ph-info class="icon-info"/>
    </div>
    <div
      v-if="show"
      class="ff-infotip__content"
      @mouseenter="maintain"
      @mouseleave="leaveMaintain"
      :style="style">
      <h1 class="ff-infotip__heading">
        {{heading}}
      </h1>
      <p class="ff-infotip__copy">
        {{copy}}
      </p>
      <div class="ff-infotip__actions" v-if="actions">
        <a
          v-for="(action, index) in actions"
          :href="action.link"
          :key="index"
          target="_blank">
          {{action.text}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { PhInfo } from "phosphor-vue";

export default {
  name: 'ff-infotip',
  props: [
    'heading',
    'copy',
    'actions'
  ],
  components: {
    PhInfo
  },
  data () {
    return {
      show: false,
      top: 0,
      left: 0
    }
  },
  computed: {
    style () {
      let s = {}
      s.top = `${this.top}px`
      s.left = `${this.left}px`
      return s
    }
  },
  methods: {
    trigger (event) {
      this.show = true
      this.left = event.target.offsetLeft
      this.top = event.target.offsetTop
    },
    triggerLeave () {
      this.show = false
    },
    maintain () {
      this.show = true
    },
    leaveMaintain () {
      this.show = false
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .ff-infotip {
    display: inline-block;
    cursor: default;
  }

  .ff-infotip__content {
    padding: $unit-1 $unit-2 $unit-2 $unit-2;
    position: fixed;
    background: $color-white;
    box-shadow: $boxShadow;
    top: 0;
    left: 0;
    z-index: 9;
    overflow-x: visible;
    overflow-y: visible;
    border-radius: 4px;
    max-width: 16em;
  }

  .ff-infotip__heading {
    font-weight: 600;
    margin: 0;
  }

</style>
